import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

interface ItemSeparatorProps {}

export const ItemSeparator: React.FC<ItemSeparatorProps> = () => {
  return <Box py={Spacing['inline.quarck']} />;
};
